// 사은품 데이타
function get_gift () {  
    const data = [
      {
        count: 20,
        title1: "20회보상",
        title2: "두써킷 티셔츠",
      },
      {
        count: 30,
        title1: "30회보상",
        title2: "두써킷 티셔츠",
      },
      {
        count: 40,
        title1: "40회 보상",
        title2: "스포츠 타월 + 5% 할인권",
      },
      {
        count: 50,
        title1: "50회 보상",
        title2: "스포츠 파우치",
      },
  
      {
        count: 60,
        title1: "60회 보상",
        title2: "스포츠 텀블러 + 10% 할인권",
      },
      {
        count: 80,
        title1: "80회 보상",
        title2: "옐로 손목 보호대",
      },
      {
        count: 140,
        title1: "140회 보상",
        title2: "화이트 손목 보호대",
      },
      {
        count: 200,
        title1: "200회 보상",
        title2: "블루 손목 보호대",
      },
      {
        count: 260,
        title1: "260회 보상",
        title2: "레드 손목 보호대",
      },
      {
        count: 320,
        title1: "320회 보상",
        title2: "블랙 손목 보호대",
      },
    ];
    return data;  
}

export default get_gift;